module.exports = __webpack_public_path__ + "static/media/gold_place.ae5d9655.svg";